import NotificationRouteAction from '@/components/common/notifications/NotificationRouteAction.vue';
import i18n from '@/i18n';
import { RouteName } from '@/router/models/route-name';
import { notificationChild } from '@/services/notification/models/notification';
import { isClientError } from 'cesg-shared';
import type { NotificationMatcher } from './notification-matcher';

export const duplicateInvoiceNotification: NotificationMatcher = (error) => {
  if (!isClientError(error, 'DUPLICATE_INVOICE_ERROR')) return null;

  const { t, te } = i18n.global;
  const textKey = `errorNotifications.DUPLICATE_INVOICE.text.${error.payload.data.matchedOn}`;
  return {
    title: t('errorNotifications.DUPLICATE_INVOICE.title'),
    text: te(textKey)
      ? t(textKey)
      : t('errorNotifications.DUPLICATE_INVOICE.text.fallback'),
    type: 'danger',
    timeout: -1,
    component: notificationChild(NotificationRouteAction, {
      label: t('errorNotifications.DUPLICATE_INVOICE.action'),
      route: {
        name: RouteName.AdminEditInvoice,
        params: { id: error.payload.data.existingId },
      },
    }),
  };
};
